import { BullpenBase } from './base/bullpen-base';

export class Bullpen extends BullpenBase { }